export default __webpack_public_path__ + "static/media/CoinbaseWallet.098d24ab.png";